<div *ngIf="!isEdited" class="cell-view">
  <div *ngIf="!showTime" class="inner-view">
    {{ rowData[fieldName] | date }}
  </div>
  <div *ngIf="showTime" class="inner-view">
    {{ rowData[fieldName] | date: 'medium' }}
  </div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="DateCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="DateCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div class="p-inputgroup">
    <p-calendar
      #calendarRef
      [name]="fieldName"
      dateFormat="dd.mm.yy"
      [style]="{ width: '100%' }"
      [showTime]="showTime"
      [inputStyle]="{ width: '100%', 'border-top-right-radius': '0px', 'border-bottom-right-radius': '0px' }"
      class="calendar-input-width-fix"
      [(ngModel)]="rowData[fieldName]"
      appendTo="body"
      [hideOnDateTimeSelect]="!showTime"
      [locale]="de"
      (click)="$event.stopPropagation()"
      (onSelect)="onDateSelect()"
      (keyup.esc)="abortCellEdit($event)"
      (onClose)="abortCellEdit($event)"
      jmlAutoFocus
    >
      <ng-template *ngIf="showTime" pTemplate="footer">
        <button
          pButton
          type="button"
          icon="pi pi-check"
          class="w-full"
          (mousedown)="save()"
          [disabled]="mandatory && !rowData[fieldName]"
        ></button>
      </ng-template>
    </p-calendar>
    <button
      pButton
      type="button"
      icon="pi pi-check"
      (mousedown)="save()"
      [disabled]="mandatory && !rowData[fieldName]"
    ></button>
  </div>
</ng-template>
